import $ from './app/jquery-shim.js';
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import CopyRight from './app/copyright.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
import buildFormat from './app/format.js';
import myScript from './scripts.js';
import OwlCarousel from 'owl.carousel';
import modaal from 'modaal';
import modal from './app/modal.js';
import {scrollfire} from "./app/scrolltrigger.js";
import anime from 'animejs';


import fontAwesome from "font-awesome/scss/font-awesome.scss";
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css";
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css";
import modaalCss from 'modaal/dist/css/modaal.css';
import slick from "slick-carousel/slick/slick.min.js";
import slickCss from "slick-carousel/slick/slick.css";
import slickTheme from "slick-carousel/slick/slick-theme.css";


class ScrollReveal {
  constructor(options) {
    this.options = options;
  }

  reveal(el, options, duration) {
    $(el).css({
      visibility: "visible",
      opacity: 0,
    })
    scrollfire(el, function () {
      // console.log(el);
      var args = {
        targets: el,
        // opacity: 1,
        // translateY: -options.distance,
        // duration: 600
      }
      args = Object.assign(options, args);
      anime(args);
    }, {
      offset: window.innerHeight
    })
  }
}

class App {
  constructor() {
    this.Utils = new Utils();
    this.Accordion = new Accordion();
    this.Anchor = new Anchor();
    this.FixedHeader = new FixedHeader();
    this.modal = new modal();
    this.CopyRight = new CopyRight();
    this.HeightLine = new HeightLine();
    this.ResponsiveTable = new ResponsiveTable();
    this.Slidebar = new Slidebar();
    this.CurrentNav = new CurrentNav();
    this.Tab = new Tab();

    //SPメニューの高さ取得
    function menuHight() {
      var win = $(window).innerWidth();
      if (win > 750) {
        return false;
      }

      var $smpHeaderHeight = $('.l-header').height();
      var windowHeight = window.innerHeight;
      var winH = windowHeight - $smpHeaderHeight;


      //動かすターゲットを取得
      var targetSlidebarWrap = $('.c-slidebar-menu'),
        targetSlidebarMenu = $('.c-slidebar__parent'),
        targetSlidebarBtn = $('.c-slidebar-menu__parent');


      //いざ実行(クリックしたら処理を実行する)
      targetSlidebarBtn.on('click', function () {
        $('.c-slidebar-menu').toggleClass('is-active');

      });
    }

    //フッターメニューSPスライド
    function menuSlide() {
      var win = $(window).innerWidth();
      if (win > 750) {
        return false;
      }
      $('.l-footer__block').on('click', function () {
        $(this).children(".l-footer__menutitle").toggleClass('is-open');
        $(this).children(".l-footer__menulist.is-sub").slideToggle();
      })
    }


    //owlcarousel
    function owlCarousel() {
      var owls = $('.owl-carousel');
      if (owls.length === 0) {
        return false
      }
      //->スライダー
      owls.imagesLoaded(function () {
        $('.c-main-visual__slider').owlCarousel({
          items: 1,
          margin: 0,
          dots: true,
          loop: true,
          nav: false,
          mouseDrag: false,
          touchDrag: false,
          autoplayHoverPause: false,
          autoplay: true,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          center: true,
          animateOut: 'fadeOut',
          // navText: ['<img src="/wp-content/themes/inter-action-html/dist/assets/images/icon-slider-prev.svg" />', '<img src="/wp-content/themes/inter-action-html/dist/assets/images/icon-slider-next.svg" />'],
        });
      });
      //->カード_カルーセル
      owls.imagesLoaded(function () {
        if ($('.js-card-slider').find('.c-card__block').length < 3) {
          $('.js-card-slider').toggleClass('owl-carousel');
          return false;
        }
        $('.js-card-slider').owlCarousel({
          margin: 0,
          dots: false,
          loop: true,
          nav: true,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          center: true,
          navText: ['<img src="/wp-content/themes/inter-action-html/dist/assets/images/icon-slider-prev.svg" />', '<img src="/wp-content/themes/inter-action-html/dist/assets/images/icon-slider-next.svg" />'],
          responsive: {
            // breakpoint from 0 up
            0: {
              items: 1,
            },
            // breakpoint from 750 up
            750: {
              items: 3,
            }
          }
        });
      });
    }

    //- スクロールリーバル
    function reveal() {
      function domEach(items, callback) {
        if (typeof items === "string") {
          var items = $(items);
        }
        for (var i = 0; i < items.length; i++) {
          var item = items[i];
          // callback = callback.bind(item)
          callback(i, item);
        }
      }

      window.sr = new ScrollReveal({duration: 600, mobile: true});
      var baseEasing = 'cubicBezier(0.175, 0.885, 0.32, 1.275)';
      var baseDistance = '12';

      sr.reveal(".l-page-header__inner", {
        opacity: [0, 1],
        duration: 600,
        delay: 600,
        translateY: [baseDistance, 0],
        easing: baseEasing
      });
      domEach(".c-card-sm__block", function (key, item) {

        sr.reveal(item, {
          scale: {
            value: [0.9, 1],
            // easing: "linear"
          },
          opacity: 1,
          duration: 600,
          delay: 100 * key,
          translateY: [-baseDistance, 0],
          easing: baseEasing
        });
      });
    }


    // slick
    function slickSlider() {

      if ($('.js-gallery-slider').length < 0) {
        return false;
      }

      if ($('.c-gallery-slider__thumbnail .c-gallery-slider__thumbnail-image').length < 2) {
        $(".c-gallery-slider__thumbnail").addClass("is-simple-none");
      }

      // 上段
      $('.c-gallery-slider__main').slick({
        infinite: true,
        arrow: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<div class="slick-prev"><img src="/wp-content/themes/inter-action-html/dist/assets/images/icon-arrow-left.png" /></div>',
        nextArrow: '<div class="slick-next"><img src="/wp-content/themes/inter-action-html/dist/assets/images/icon-arrow-next.png" /></div>',
        asNavFor: '.c-gallery-slider__thumbnail',
        autoplaySpeed: 2500,
        // centerPadding: '23.28%',
        centerMode: true,
        variableWidth: true,
        dots: false,
        responsive: [{
          breakpoint: 750,
          settings: {
            variableWidth: false,
            autoplaySpeed: 2500,
            slidesToShow: 1
          }
        }]
      });

      // 下段
      $('.c-gallery-slider__thumbnail').slick({
        accessibility: true,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 400,
        arrows: false,
        dots: false,
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.c-gallery-slider__main',
        focusOnSelect: true,
        responsive: [{
          breakpoint: 750,
          settings: {
            variableWidth: false,
            autoplaySpeed: 2500,
            slidesToShow: 4
          }
        }]
      });
    }

    /**
     * ループスライダー
     */
    function loopSlider() {
      var targetInner = $('.js-loop-slider'),
        targetInnerUl = $('.js-loop-slider > ul'),
        targetInnerItems = targetInnerUl.children(),
        slideEasing = 'linear',
        slideSpeed = 6000;
      for (var i = 0; i < 2; i++) {
        targetInnerItems.clone().prependTo(targetInnerUl);
        targetInnerItems.clone().appendTo(targetInnerUl);
      }
      targetInnerUl.each(function () {
        var self = $(this);
        //liの個数を取得
        var selfChildItemLength = self.find('li').length;
        //liの幅を取得
        var selfChildList = self.find('li').innerWidth();
        //ulを複製する
        // self.clone().appendTo( targetInner );
        //ulの親divに幅を付与する
        // targetInner.width( ( selfChildList * selfChildItemLength ) * 2 )
        targetInner.width(selfChildList * selfChildItemLength);

        // 親divをアニメーションさせる
        function galleryAnimate() {
          targetInner.animate(
            {
              left: '-' + ((selfChildList * selfChildItemLength) / 3 * 2) + 'px'
            }, {
              duration: slideSpeed * selfChildItemLength,
              easing: slideEasing,
              complete: function () {
                targetInner.css({
                  left: 0
                });
                galleryAnimate()
              }
            }
          );
        }

        galleryAnimate()
      });
    }

    function spanWrap() {
      // コンテナを指定する
      var container = $(".js-span-wrap-text");

      $.each(container, function(index,value) {

        if ($(value).hasClass("js-strong-add")) {

          // コンテナのコンテンツを取得
          let content = $(value).find("strong");
          let newHTML = "";

          for (const string of content) {

            const text = $(string).text();
            for (let char of text) {
              newHTML +=  "<span class='c-main-visual__cell'>" + char + "</span>";
            }

            // コンテナに作ったHTMLを挿入しする
            $(string).html(newHTML);
            newHTML = "";
          }

        } else {

          // コンテナのコンテンツを取得
          var content = $(value).html();

          // コンテンツから空白や改行を削除
          var text = $.trim(content);

          // 新しく挿入するHTMLの変数を定義
          var newHtml = "";

          // text を1文字ずつ分割して span を追加する
          text.split("").forEach(function (v) {

            // if (v === " ") {
            //   newHtml += v;
            // } else {
            newHtml += "<span class='c-main-visual__cell'>" + v + "</span>";
            // }
          });

          // コンテナに作ったHTMLを挿入しする
          $(value).html(newHtml);

        }
      });

      spanAddDelay();
    }

    function spanAddDelay() {
      const target = $(".c-main-visual__cell");
      let delay = 0;

      for (const char of target) {
        delay += 0.08;
        $(char).css('animation-delay', delay+"s");
      }
    }

    function mvAnimation() {


      const $mv = $('.c-main-visual');
      $mv.css('height', window.innerHeight);
      const $mvTitle = $('.c-main-visual__title');
      const $mvText = $('.c-main-visual__text');

      $(window).on('load', () => {
        $mv.css('height', 'auto');

        //コンストラクタ
        function changeClass(el, className, time) {
          //Promiseを使用
          return new Promise(function (resolve, reject) {
            setTimeout(function () {
              el.addClass(className);
              //resolve処理が成功したら
              resolve(className);
            }, time);
          });
        }

        var loadAnim = function () {
          changeClass($mv, "is-trigger-01", 800).then(function () {
            changeClass($mvTitle, "is-trigger-02", 800).then(function () {
              changeClass($mvText, "is-trigger-03", 3400).then(function () {
              });
            });
          });
        };

        loadAnim();


      });
    }

    $(function () {
      menuSlide();
      owlCarousel();
      reveal();
      slickSlider();
      loopSlider();
      spanWrap();
      mvAnimation();
    });
  }
}

window.GApp = new App();
